import { Component } from 'preact';
import TextWrapper from "../../util/wrapper/TextWrapper";

export default class FooterForm extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const {id, footerText, showWithoutFooterText, config, icon, additionalContent} = this.props;

        const isSentenceFormatReversed = ['chi', 'jpn'].includes(config.language.toLowerCase());

        return (
            <footer className="body__footer footer">
                {
                    (footerText || showWithoutFooterText) &&

                    <aside className="footer__message" role="alert" aria-live="assertive">
                        <TextWrapper Tag="p"
                                     id={id}
                                     contentBefore={
                                         isSentenceFormatReversed ?
                                             <span>
                                                 {icon}
                                                 {footerText}
                                             </span> :
                                             icon
                                     }
                                     contentAfter={isSentenceFormatReversed ? '' : footerText}
                                     spaceBetweenPrefix={isSentenceFormatReversed}
                                     spaceBetweenSuffix={!isSentenceFormatReversed}/>
                        {additionalContent && additionalContent}
                    </aside>
                }
            </footer>
        );
    }
}
